<template>
  <v-container id="clients" fluid tag="section">
    <div class="text-right">
      <v-btn
        color="cyan"
        @click="showFilter = !showFilter"
        small
        v-if="showGrid"
      >
        <v-icon>mdi-filter</v-icon>
      </v-btn>
      <v-btn
        color="secondary"
        class="mr-0"
        small
        v-if="singlePage && !showGrid"
        @click="
          showGrid = !showGrid;
          client_id = null;
        "
      >
        <v-icon v-if="!showGrid" class="me-3">mdi-grid</v-icon>
        {{ $i18n.t("View All Clients") }}
      </v-btn>
      <v-menu offset-y v-if="showGrid">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="secondary" small>
            <h3>
              {{ $i18n.t("Action") }}
              <v-icon>mdi-menu-down</v-icon>
            </h3>
          </v-btn>
        </template>
        <v-list>
          <v-list-item :to="'/settings/client/add'" v-if="!singlePage">
            <v-list-item-title>{{ $i18n.t("Create") }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="uploadC()" v-if="!singlePage">
            <v-list-item-title>{{ $i18n.t("Bulk Upload") }}</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="singlePage"
            @click="
              showGrid = !showGrid;
              client_id = null;
            "
          >
            <v-icon>mdi-plus</v-icon>
            <v-list-item-title>{{ $i18n.t("Add New") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <client-add
      v-if="!showGrid && clientAdd"
      :singlePage="singlePage"
      :owner_id="owner_id"
      @select="select"
    />

    <client-edit
      v-if="!showGrid && !clientAdd"
      :client_id="client_id"
      :singlePage="singlePage"
      @select="select"
    />

    <v-row justify="center" v-if="showFilter && showGrid">
      <v-col cols="12" md="12">
        <base-material-card
          color="cyan"
          icon="mdi-filter"
          class="px-3 py-1 small-icon mt-5"
          v-if="showFilter"
        >
          <div class="filter-close">
            <v-btn
              color="black"
              class="mr-0"
              fab
              small
              text
              @click="showFilter = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-row>
            <v-col cols="12" md="2">
              <v-text-field
                :label="$i18n.t('Name')"
                class="purple-input"
                v-model="filters.fullName"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                :label="$i18n.t('Unique ID')"
                class="purple-input"
                v-model="filters.unique_id"
              />
            </v-col>

            <v-col cols="12" md="2">
              <v-select
                v-model="filters.approved"
                :items="statuses"
                :label="$i18n.t('Status')"
              />
            </v-col>
            <v-col cols="12" md="2">
              <z-country-select v-model="filters.country" />
            </v-col>
            <v-col cols="12" md="2">
              <z-city-select
                v-model="filters.city"
                :country="filters.country"
              />
            </v-col>

            <v-col cols="12" md="3" class="text-right">
              <v-btn
                color="cyan"
                class="mr-2"
                small
                dark
                @click="downloadC()"
                :loading="loading"
              >
                {{ $i18n.t("Download") }} <v-icon>mdi-cloud-download-outline</v-icon>
              </v-btn>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-0"
                    color="grey darken"
                    small
                    @click="clear(1)"
                    style="margin-right: 10px !important"
                    v-on="on"
                  >
                    {{ $i18n.t("Refresh") }} <v-icon>mdi-cached</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Clear Filter") }}</span>
              </v-tooltip>
              <v-btn
                color="success"
                class="mr-0"
                small
                dark
                @click="search()"
                :loading="loading"
              >
                {{ $i18n.t("Search") }} <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>

    <v-btn
      v-if="showGrid && grid != undefined && !grid.records"
      class="text-center secondary--text pa-10"
      text
      color="primary"
      style="width: 100%"
      :loading="loading"
      >{{ $i18n.t("No records available") }}</v-btn
    >

    <base-material-card
      icon="mdi-domain"
      :title="$i18n.t('Clients')"
      class="px-5 py-3 small-icon mt-5"
      v-if="showGrid && grid.records"
      color="primary"
    >
      <z-grid-record :grid="grid" />
      <v-simple-table>
        <thead>
          <tr>
            <th class="primary--text">{{ $i18n.t("ID") }}</th>
            <th class="primary--text">{{ $i18n.t("Name") }}</th>
            <th class="primary--text">{{ $i18n.t("Address") }}</th>
            <th class="primary--text">{{ $i18n.t("Admin Name") }}</th>
            <th class="primary--text">{{ $i18n.t("Admin Email") }}</th>
            <th class="primary--text">{{ $i18n.t("Admin Phone") }}</th>
            <th class="primary--text">{{ $i18n.t("Status") }}</th>
            <th class="text-right primary--text">{{ $i18n.t("Action") }}</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="client in grid.rows" :key="client._id">
            <td>{{ client.client.unique_id }}</td>
            <td>{{ client.client.name }}</td>
            <td>
              <span v-if="client.address.city" title="City"
                >{{ client.address.city }},</span
              >
              <span v-if="client.address.country" title="Country"
                >, {{ client.address.country }}</span
              >
            </td>
            <td><span v-if="client.adminUser">{{ client.adminUser.name }}</span></td>
            <td><span v-if="client.adminUser">{{ client.adminUser.email }}</span></td>
            <td>
              <span v-if="client.adminUser">
              +{{ client.adminUser.countryCode }}-{{ client.adminUser.phone }}
              </span>
            </td>
            <td>
              <span v-if="client.client.approved">
                <z-confirm-button
                  small
                  fab
                  text
                  class="btn btn-green rounded btn-u-xs"
                  @click="sendClientValue(client._id, 0)"
                  :message="$i18n.t('Are you sure you want to unapprove this?')"
                >
                  <v-icon>mdi-check</v-icon>
                </z-confirm-button>
              </span>
              <span v-if="!client.client.approved">
                <z-confirm-button
                  small
                  fab
                  text
                  class="btn btn-warning rounded btn-u-xs"
                  @click="sendClientValue(client._id, 1)"
                  :message="$i18n.t('Are you sure you want to approve this?')"
                >
                  <v-icon>mdi-close</v-icon>
                </z-confirm-button>
              </span>
            </td>
            <td>
              <z-confirm-button
                v-if="client.showDelete && !client.isPremium"
                class="float-right"
                color="red lighten-1"
                small
                fab
                text
                dark
                :message="$i18n.t('Do you want to remove this client ?')"
                @click="deleteClient(client)"
              >
                <v-icon>mdi-trash-can-outline</v-icon>
              </z-confirm-button>
              <v-tooltip top v-if="!singlePage">
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="float-right"
                    color="primary"
                    small
                    fab
                    text
                    dark
                    :to="'/settings/client/' + client._id"
                    v-on="on"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Edit") }}</span>
              </v-tooltip>
              <v-tooltip top v-if="singlePage">
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="float-right"
                    color="primary"
                    small
                    fab
                    text
                    dark
                    @click="editClient(client._id)"
                    v-on="on"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Edit") }}</span>
              </v-tooltip>
              <v-tooltip top v-if="showSelectBtn && client.client.approved">
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="float-right"
                    color="success"
                    small
                    fab
                    text
                    dark
                    @click="select(client)"
                    v-on="on"
                  >
                    <v-icon>mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Select") }}</span>
              </v-tooltip>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-container>
        <v-row justify="center">
          <v-col cols="8">
            <v-container class="max-width">
              <v-pagination
                v-model="grid.page"
                class="my-4"
                :length="grid.total"
                total-visible="10"
                @input="showPage"
              ></v-pagination>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </base-material-card>

    <z-download-file
      :requestURL="downloadClientsUrl"
      :showDialog="showDownloadByTemplateDialog"
      @closeDialog="closeDialog"
      :kind="6"
      :forUpload="forUpload"
    />
  </v-container>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import ClientAdd from "@/views/client/ClientAdd.vue";
import ClientEdit from "@/views/client/ClientEdit.vue";
import corpService from "@/store/common/module/CorpService";
import { CommonUtil } from "@/js/commonUtil";

@Component({
  components: {
    ClientAdd,
    ClientEdit,
  },
  props: {
    singlePage: {
      default: false,
    },
    showGrid1: {
      default: true,
    },
    showSelectBtn: {
      default: false,
    },
    owner_id: {
      default: null,
    },
  },
})
export default class Clients extends Vue {
  grid = { page: 0 , rows:[]};
  rows = 20;
  url = "/api/corp/client/vendor/data/clients?rows=" + this.rows;
  showFilter = false;
  filterUrl = "";
  page = 1;
  showGrid = true;
  client_id = null;
  clientAdd = true;

  showDownloadByTemplateDialog = false;
  forUpload = false;

  filters = {
    fullName: null,
    unique_id: null,
    country: null,
    city: null,
    approved: null,
  };

  statuses = [
    { value: "true", text: "Approved" },
    { value: "NULL", text: "Penidng" },
  ];

  downloadClientsUrl = null;
  async downloadC() {
    const downloadUrl =
      "/api/corp/download/client?_search=true" + this.getFilteredUrl();
    this.downloadClientsUrl = downloadUrl;
    this.forUpload = false;
    this.showDownloadByTemplateDialog = true;
  }

  async uploadC() {
    this.downloadClientsUrl = "/api/corp/upload/clients?_search=true" + this.getFilteredUrl();
    this.forUpload = true;
    this.showDownloadByTemplateDialog = true;
  }

  get loading() {
    return common.loading;
  }

  closeDialog(reload) {
    this.showDownloadByTemplateDialog = false;
    common.setLoading(false);
    if (reload) this.reload();
  }

  async reload() {
    this.showPage(this.page);
  }

  editClient(_id) {
    //This is used for single page application
    this.client_id = _id;
    this.showGrid = false;
    this.clientAdd = false;
  }

  select(data) {
    this.$emit("select", { _id: data._id, name: data.client.name });
    this.showGrid = true;
  }

  @Watch("showGrid")
  onChangeShowGrid(newVal){
    this.$emit("showingGrid", newVal);
    
  }

  async mounted() {
    common.setLoading(true);
    this.showGrid = this.showGrid1;
    try {
      this.grid = await doGet(this.url);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async showPage(page) {
    this.page = page;
    this.grid = await doGet(this.url + this.filterUrl + "&page=" + page);
    common.setLoading(false);
  }

  async clear() {
    this.filters = {};
    this.page = 1;
    this.search();
  }

  getFilteredUrl() {
    let filterUrl = "";
    if (this.filters.fullName)
      filterUrl += "&fullName=" + this.filters.fullName;
    if (this.filters.unique_id)
      filterUrl += "&unique_id=" + this.filters.unique_id;
    if (this.filters.country)
      filterUrl += "&country=" + this.filters.country;
    if (this.filters.city) this.filterUrl += "&city=" + this.filters.city;
    if (this.filters.approved)
      filterUrl += "&approved=" + this.filters.approved;

    return filterUrl;
  }

  async search() {
    this.filterUrl = this.getFilteredUrl();
    common.setLoading(true);
    await this.showPage(1);
  }

  async sendClientValue(id, status) {
    try {
      await doGet("/api/corp/" + id + "/approve/client/" + status);
      common.showMessage("Status Successfully Updated");
      await this.search();
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async deleteClient(client) {
    try {
      await doGet("/api/client/" + client._id + "/delete");
      common.showMessage("Deleted Successfully");
      await this.search();
      await corpService.populateClients();
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}
.dialog {
  position: fixed;
  top: 100px;
  width: 60%;
  z-index: 10;
  margin-left: 15%;
}
.btn-list-item {
  padding: 0;
  float: left !important;
}
.btn-list-item .v-btn--text {
  padding: 0;
  text-transform: none;
  font-size: 14px;
  float: left;
  margin: 0;
}
</style>
